export const ShoppingCardIsEmpty = "You do not have any classes or product in your order as yet. Please <a href=\"/courses\">select a class</a> from the courses available."
